import _defineProperty from "/home/sa_jenkins/workspace/PROD10_Frontend_Build_CEAMP/V11.4.1/CEAMP/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import sortOn from "sort-on";
import { DateTime } from "luxon";
import rawTimeZones from "../raw-time-zones.json";
import formatTimeZone from "./formatTimeZone.js";
export default function getTimeZones() {
  return sortOn(rawTimeZones.reduce(function (acc, timeZone) {
    var currentDate = DateTime.fromObject({
      locale: "en-US",
      zone: timeZone.name
    });

    // We build on the latest Node.js version, Node.js embed IANA databases
    // it might happen that the environment that will execute getTimeZones() will not know about some
    // timezones. So we ignore the timezone at runtim
    // See https://github.com/vvo/tzdb/issues/43
    if (currentDate.isValid === false) {
      return acc;
    }
    var timeZoneWithCurrentTimeData = _objectSpread({}, timeZone, {
      currentTimeOffsetInMinutes: currentDate.offset
    });
    acc.push(_objectSpread({}, timeZoneWithCurrentTimeData, {
      currentTimeFormat: formatTimeZone(timeZoneWithCurrentTimeData, {
        useCurrentOffset: true
      })
    }));
    return acc;
  }, []), ["currentTimeOffsetInMinutes", "alternativeName", "mainCities[0]"]);
}